export default {
  work: 'Lead Front Developer',
  workDelivery: 'Mobile Apps/ Web Site',
  french: 'French',
  english: 'English',
  german: 'German',
  residence: 'Residence',
  carlicense: 'Car license',
  Contact: 'Contact',
  city: 'City',
  age: 'Age',
  france: 'France',
  discover: 'Passionate developer,',
  world: 'Support businesses in creating custom web and mobile applications',
  explore: 'EXPLORE NOW',
  yearsExperience: 'Years Experience',
  appProduction: 'Apps in production',
  projectFinish: 'Completed Projects',
  useTechnology: 'technologies used',
  myService: 'My services',
  contactMe: 'Contact me',
  proSucess: 'My Projects in Production',
  devWebTitle: 'Website development',
  devWebContent: 'I support businesses on freelance missions in creating high-performance websites with React.js and Next.js, handling the entire project: architecture design, performance and SEO optimization, workflow automation, and deployment to maximize your users’ visibility and engagement.',
  devAppTitle: 'Mobile application development',
  devAppContent: 'I support businesses on freelance missions in creating high-performance mobile applications with React Native, handling the entire project: architecture design, workflow automation, optimization, and deployment to the stores to maximize the impact and engagement of your users.',
  designTitle: 'Mockups & HTML Integration',
  designContent: 'I create custom mockups and designs with Figma and Canva, optimizing the user experience, and I am capable of integrating them into any website or mobile application. I also master JavaScript, HTML, and CSS to turn designs into functional and interactive interfaces.',
  hostingTitle: 'Hosting',
  hostingContent: 'Your website, database, api are hosted on a server, robust, supporting the rise in load and located closer to your visitors. We can use dedicated servers (like OVH) or solutions directly in the cloud (AWS, GCP).',
  maintenanceTitle: 'Maintenance',
  maintenanceContent: 'A healthy website (or mobile application) is an updated website. For a better user experience and security, maintenance is mandatory.',
  storeTitle: 'Management of mobile application stores (App Store, Play Store)',
  storeContent: 'Application creation on the stores. Validation of applications on the stores. Configuration of the application\'s page. Optimization for the referencing of the application (ASO).',
  recommendationTitle1: 'Valentin l\'adulte',
  recommendationTitle2: 'Leo maltraiter',
  recommendations: 'Recommendations',
  appFromScratch: 'Creation of an application from scratch',
  siteFromScratchCRM: 'Creation of an CRM from scratch',
  appFromScratchCRM: 'Creation of an CRM mobile app from scratch',
  siteFromScratchCMDB: 'Creation of a CMDB from scratch in React JS',
  siteFromScratchSupport: 'Creation of a ticketing site from scratch in React Native',
  appFromScratchSupport: 'Creation of a ticketing mobile app from scratch in React Native',
  siteFromScratchLeadDevCyllene: 'Coaching and skills development of a team of developers',
  subSiteFromScratchCRM: 'Customer Relationship Management',
  subSiteFromScratchCMDB: 'Inventory management',
  subSiteFromScratchSupport: 'Ticket management - digital support',
  subSiteFromScratchLeadDevCyllene: 'Mentoring of HODICQ William and Matthis Ducrout in ReactJS',
  download: 'downloads',
  languageUsed: 'Language used',
  deployTechno: 'Deployment technology  - CI/CD',
  with: 'with',
  for: 'for',
  featuresMobile: 'Mobile Features',
  featuresWeb: 'Web Features',
  payOnline: 'Online payment',
  interApp: 'Internationalization of the application',
  libraryUsed: 'Libraries used',
  jobFeature: 'Business features developed',
  participateCampaign: 'Participation in campaigns.',
  answerSurvey: 'Respond to surveys.',
  participationMission: 'Participation in ambassador missions.',
  profile: 'Connection, registration, editing of his profile.',
  unConnectAccess: 'Access to the application in offline mode.',
  linkRS: 'Linking social networks (Instagram, tiktok, twitch, facebook) on its profile.',
  billing: 'Edition of administrative data in several steps.',
  tunnelRegister: 'Multi-stage registration with social networking and internal moderation.',
  participateCampaignRs: 'Participation in campaigns following social networks, influencer compensation and administrative data.',
  bfanTitle: 'Implementation of React native on existing applications for bFan Sport !',
  bfanDesc: '70 applications on the stores (AS Monaco, Stade-Francais, Paris-FC...)',
  bfanDev: 'Developed features',
  intReact: 'Integration of React Native on existing mobile applications in production (Play Store, App Store).',
  dev2View: 'Development of 2 new views in React Native with bridges and native modules (Swift, Java Android).',
  updateAPP: 'Update of React Native on Android and iOS.',
  mapDynamic: 'Creation of an interactive map in JavaScript for the Grand Prix du Castelet 2019 in production available on the Play Store and the App Store.',
  improveAuto: 'Improvement and automation of the IOS application creation process (Ruby, Fastlane, AWS).',
  deployment: 'Deployment of applications on the stores.',
  store: 'Store',
  campaign: 'Campaign',
  presentation: 'Connected',
  unConnected: 'Not connected',
  myProfile: 'My profile',
  expérimenté: 'Experienced',
  dérouillard: 'Resourceful',
  confirmé: 'Skilled',
  txt1Writter: 'Available for a long-term mission in Paris or fully remote',
  txt2Writter: 'React Native & React JS',
  txt3Writter: 'I support companies in their digital transformation',
  crmDesc1: 'Centralizes all customer information in dedicated records',
  crmDesc2: 'Organizes and tracks the different contacts linked to each customer',
  crmDesc3: 'Records and monitors sales opportunities throughout the sales cycle',
  crmDesc4: 'Integrates communication to send emails or make calls directly from the CRM',
  supportDesc1: 'Centralized ticketing site to manage all support requests',
  supportDesc2: 'Enables creating, editing, and updating tickets, including their status',
  supportDesc3: 'Provides integrated messaging to communicate directly within each ticket',
  supportDesc4: 'Allows linking tickets to Jira for better tracking and smooth collaboration',
  supportDesc5: 'Simplifies overall request tracking through status management and updates',
  cmdbDesc1: 'Centralized inventory site listing the company’s hardware and services',
  cmdbDesc2: 'Allows tracking each item through a tailored workflow (configuration, validation, installation, etc.)',
  cmdbDesc3: 'Provides a clear view of progression, from registering equipment to putting it into production',
  cmdbDesc4: 'Simplifies lifecycle management of assets and services, from configuration to installation at the client’s site',
  cmdbDesc5: 'Ensures complete tracking of sales and installations, with each workflow ending in production',
  mobileCrmDesc1: 'Mobile CRM application focused on incoming calls to quickly identify the client who is calling',
  mobileCrmDesc2: 'Displays a pop-up with the client’s name if the number is recorded in our database',
  mobileCrmDesc3: 'Allows managing contacts directly on the phone: add, edit, or delete a contact',
  mobileCrmDesc4: 'Provides the same functionalities as the web CRM: add clients, manage opportunities, and track interactions',
  mobileCrmDesc5: 'Boosts sales productivity by combining contact management and sales tracking in a mobile app',
  mobileSupportDesc1: 'Mobile support application allowing creation, editing, tracking, and updating of tickets',
  mobileSupportDesc2: 'Sends push notifications when a ticket is updated, a message is sent, or added to a ticket',
  mobileSupportDesc3: 'Enables technicians to track their tasks and ticket progress directly from their phone',
  mobileSupportDesc4: 'Provides the same ticket management as the web platform but optimized for Android and iPhone',
  mobileSupportDesc5: 'Boosts field productivity by allowing real-time ticket management and communication',
  siteCylleneLeadDevDesc1: 'Lead developer supervising a team of 2 people and mentoring them on React.js skills',
  siteCylleneLeadDevDesc2: 'Organized learning workshops and conducted code reviews across multiple projects',
  siteCylleneLeadDevDesc3: 'Planned and led team meetings, handled deployments, and managed production bugs',
  siteCylleneLeadDevDesc4: 'Monitored production errors using centralized reports (Sentry)',
  siteCylleneLeadDevDesc5: 'Responsible for DevOps practices, CI/CD, and deployment automation',
  developer: 'Developers',
  projectWeb: 'My web projects',
  projectMobile: 'My mobile projects',
  home: 'Home',
  footerDesc: 'All Rights Reserved',
  email: 'Email',
  accountClient: 'Client management',
  detectCall: 'Call detection',
  contactManagement: 'Contact management',
  editTicket: 'Ticket editing',
  listTicket: 'Ticket list',
  createTicket: 'Ticket creation',
  webediaAppsContent: '2 Public-Facing Apps for Webedia',
  recommendationJob1: 'Production Director - Cyllene',
  recommendationJob2: 'CTO - Volt',
  recommendationJob3: 'Solution Architect - AWS',
  recommendationJob4: 'Head of Digital Division - Cyllene',
  recommendationJob5: 'CTO - Webedia Creators',
  recommendationJob6: 'Developer - Cyllene',
  recommendationContent1: 'I worked with Jérôme at Webedia and later invited him to join Cyllene, where I became his manager. He delivered projects in record time while also providing valuable advice and expertise. I highly recommend him for his strong technical expertise.',
  recommendationContent2: 'Jérôme built two applications from scratch while I was CTO at Webedia. I was able to trust him completely. All deadlines were met and the applications were highly stable. He managed the app stores, the development team, and the app deployment, demonstrating a very autonomous profile.',
  recommendationContent3: 'Jérôme integrated React Native into two applications already available on the app stores. During his apprenticeship, he demonstrated strong autonomy and was proactive in proposing solutions. He came up with the idea of automating the iOS app creation process. Thanks to him, our sales teams were able to demonstrate client-branded apps directly during tender processes.',
  recommendationContent4: 'Supported by Jérôme in the development of two React Native applications for our clients and technicians, we benefited from his expertise throughout the project. Jérôme helped us improve the apps by sharing his insights and suggesting new ideas, adding real value to the project.',
  recommendationContent5: 'I replaced the CTO at Webedia, and Jérôme had already delivered the Sampleo application. We then worked together on the second application, MyCreators. Everything went smoothly from design to deployment. Two years after his departure, the applications are still running just as well.',
  recommendationContent6: 'As a lead developer, he established a solid technical framework, made the right architectural decisions, and ensured excellent code quality while meeting deadlines. Beyond his technical skills—particularly in web and mobile development with React—Jérôme is an excellent mentor. Coming from a career transition myself, I was able to grow significantly thanks to him through pair programming, constructive code reviews, and guidance on best practices.',
  seeProfil: 'View profile',
  statsProducts: 'digital products developed',
  statsExperience: 'years in the React ecosystem',
  statsStacks: 'modern stacks mastered',
  statsApps: 'web & mobile applications live',

};
